import { render, staticRenderFns } from "./setting-accountInformation.vue?vue&type=template&id=1879aac0&scoped=true&"
import script from "./setting-accountInformation.vue?vue&type=script&lang=js&"
export * from "./setting-accountInformation.vue?vue&type=script&lang=js&"
import style0 from "./setting-accountInformation.vue?vue&type=style&index=0&id=1879aac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1879aac0",
  null
  
)

export default component.exports